import styled from "styled-components";

import { KeepWatchingMobileSlidesLoadingSkeletonContainer } from "pages/[tenant]/feed/components/molecules/KeepWatchingMobileSlides/LoadingSkeleton/styles";

export const KeepWatchingMobileSlidesContainer = styled.div`
  width: 100%;

  max-width: calc(100vw - 2rem);
  display: flex;
  flex-direction: column;
  gap: 1rem;

  :has(${KeepWatchingMobileSlidesLoadingSkeletonContainer}) {
    max-width: initial;
  }

  .swiper {
    display: flex;
    flex-direction: row;

    overflow: visible;

    width: 100%;

    margin-left: auto;
    margin-right: auto;

    .swiper-button-prev,
    .swiper-button-next {
      opacity: 0;
      pointer-events: none;
    }
  }
`;
